import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom";
import { filterValue } from "utils/helpers";

export function useFilterInput(bindQuery) {

    const [searchParams, setSearchParams] = useSearchParams();
    const [filterInputValue, setFilterInputValue ] = useState('');

    // Inizializza il valore dal parametro URL quando il componente viene montato
    useEffect(() => {
        const searchParam = searchParams.get('s');
        if (searchParam) {
            setFilterInputValue(searchParam);
        }
    }, []);

    const filterSearchArray = item => {
        return filterValue(
            filterInputValue,
            bindQuery(item)
        ) ? item : false;
    }
    

    const handleFilterInputChange = (e) => {
        const newValue = e.target.value;
        setFilterInputValue(newValue);
        
        // Aggiorna il parametro URL
        const newSearchParams = new URLSearchParams(searchParams);
        if (newValue) {  
            newSearchParams.set('s', newValue);
        } else {
            newSearchParams.delete('s');
        }
        setSearchParams(newSearchParams);
    }

    // Funzione custom per aggiornare sia lo stato che l'URL direttamente da una stringa
    const setFilterInputValueAndUrl = (value) => {
        setFilterInputValue(value);
        const newSearchParams = new URLSearchParams(searchParams);

        if (value) {
            newSearchParams.set('s', value);
        } else {
            newSearchParams.delete('s');
        }
        setSearchParams(newSearchParams);
    }

    return [
        filterInputValue,
        handleFilterInputChange,
        filterSearchArray,
        setFilterInputValue, // Aggiungi questa riga per esportare la funzione di aggiornamento del filtro
        setFilterInputValueAndUrl // Esporta anche la funzione custom
    ]
}

export function useFilterBuilding() {
    
    return useFilterInput(building => {
        return `${building.address.full}${building.title}`;
    });
}

export function useFilterOrganization() {
    
    return useFilterInput(organization => {
        return `${organization.display_name}${organization.vat_code}${organization.fiscal_code}${organization.business_name}`;
    });
}
